export class IncludeInfo {
    includeField: string;
    constructor(item: string) {
        this.includeField = item;
    }
}
